var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0648 29.25C26.8198 31.11 25.4998 32.925 23.4898 32.955C21.4798 33 20.8348 31.77 18.5548 31.77C16.2598 31.77 15.5548 32.925 13.6498 33C11.6848 33.075 10.1998 31.02 8.93977 29.205C6.37477 25.5 4.40977 18.675 7.04977 14.085C8.35477 11.805 10.6948 10.365 13.2298 10.32C15.1498 10.29 16.9798 11.625 18.1648 11.625C19.3348 11.625 21.5548 10.02 23.8798 10.26C24.8548 10.305 27.5848 10.65 29.3398 13.23C29.2048 13.32 26.0848 15.15 26.1148 18.945C26.1598 23.475 30.0898 24.99 30.1348 25.005C30.0898 25.11 29.5048 27.165 28.0648 29.25ZM19.4998 5.25C20.5948 4.005 22.4098 3.06 23.9098 3C24.1048 4.755 23.3998 6.525 22.3498 7.785C21.3148 9.06 19.6048 10.05 17.9248 9.915C17.6998 8.19 18.5398 6.39 19.4998 5.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.bf35d84a766b6c1348fa64d783c9146f.svg";
export { ForwardRef as ReactComponent };